import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import LoginForm from "../components/Forms/LoginFrom";
//import { Modules } from "../Style/Modules";
// import '../Style/Modules/login.module.css';
import styles from "../Style/Modules/login.module.css";
import "../Style/Theme/index.css";
import ContainerWithLogo from "./ContainerWithLogo";

export default function LoginP() {
  useEffect(() => {
    // When the user navigates to this page
    window.history.pushState(null, null, window.location.href);

    // Attach an event listener to prevent navigation
    const handlePopstate = (event) => {
      // Check if the user is on the specific page
      // if (window.location.pathname === "/specific-page") {
      // Push another state to stay on the page
      window.history.pushState(null, null, window.location.href);
      // }
    };
    window.addEventListener("popstate", handlePopstate);

    return () => {
      // Cleanup: remove the event listener
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);
  return (
    <>
      <ContainerWithLogo>
        <LoginForm />
      </ContainerWithLogo>
    </>
  );
}
